import { render, staticRenderFns } from "./Sucker.vue?vue&type=template&id=4177e9ba"
import script from "./Sucker.vue?vue&type=script&lang=js"
export * from "./Sucker.vue?vue&type=script&lang=js"
import style0 from "./Sucker.vue?vue&type=style&index=0&id=4177e9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports